import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import styles from './styles';

export function ChipIcon(props) {
  const { classes, iconContent } = props;

  return (
    <div data-testid='chip-icon' className={classes.icon}>
      {iconContent}
    </div>
  );
}

ChipIcon.propTypes = {
  classes: PropTypes.object,
  /** Content to be placed in chip icon */
  iconContent: PropTypes.node,
  /** Color for background of chip. Used in styles file */
  iconColor: PropTypes.string,
};

export default withStyles(styles)(ChipIcon);
